// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/styles/" + chunkId + "." + {287: "9e39d8f53eccd8c2",3657: "2ab66cc0d70906ce",}[chunkId] + ".css"
}